import React from 'react';

import { TopBar, Icon, OptionalSection } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Style from '../topBarModules.module.css';
import i18n from 'i18next';

export default function Help({ organization }) {
    const { t } = useTranslation();
    const locale = i18n.language;

    const lang = React.useMemo(() => {
        let _country = 'en';
        if (locale) {
            let _locale = locale.replace('_', '-');
            _country = _locale.split('-')[0].toLowerCase();
        }
        return !['fr', 'en', 'es'].includes(_country) ? 'en' : _country;
    }, [locale]);

    if (!organization || !organization.business_entity?.informations) {
        return null;
    }

    const informations = React.useMemo(() => {
        if (organization?.default_locale === 'en_US') {
            // special case we use canadian help informations
            return {
                phone: '+1 514-419-2666',
                technical_support_phone: '+33 (0)1 86 65 24 24',
                mailto: 'info@weezevent.com'
            };
        }
        return organization.business_entity.informations;
    }, [organization]);

    return (
        <TopBar.Help
            size={'maxi'}
            tooltipTitle={t('ticket.creationEvent.help.titleHelp')}
            items={[
                <TopBar.Help.Item
                    key="1"
                    links={[
                        {
                            icon: <Icon name="help" />,
                            title: t('ticket.creationEvent.help.labelLinkHelp'),
                            href: `https://support.weezevent.com/${lang}`
                        },
                        {
                            icon: <Icon name="book" />,
                            title: t('ticket.creationEvent.help.labelQuickStart'),
                            href: `https://support.weezevent.com/${lang}`
                        },
                        {
                            icon: <Icon name="chat" />,
                            title: t('ticket.creationEvent.help.labelSendMail'),
                            href: `mailto:${informations.mailto}`
                        }
                    ]}
                />,
                <TopBar.Help.Item
                    key="2"
                    text={
                        <OptionalSection label={t('ticket.creationEvent.help.titleContact')}>
                            <div>
                                {t('ticket.creationEvent.help.labelPhone')}
                                <div className={Style['help__phone']}>
                                    <Icon name="phone" />
                                    {informations.phone}
                                </div>
                            </div>
                            <div>
                                {t('ticket.creationEvent.help.labelPhoneEmergency')}
                                <div className={Style['help__phone']}>
                                    <Icon name="phone" />
                                    {informations.technical_support_phone}
                                </div>
                            </div>
                        </OptionalSection>
                    }
                />
            ]}
        />
    );
}
